import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import Tooltip from "@material-ui/core/Tooltip";
import moment from "moment";
import { formatStatus, renderSortArrow } from "../../lib/helperFuncs.jsx";
import {
    FIRST_PAGE,
    PREV_PAGE,
    NEXT_PAGE,
    LAST_PAGE,
    ASC,
    DESC,
    sortableFields,
    MATERIAL_UI_PROPS,
} from "../../lib/data";
import css from "../../../../sass/reservations_grid.module.scss";
import { ThemeProvider } from "@material-ui/core";
import { removeButtonTheme } from "../../config/theme";
import RemoveCircle from "@material-ui/icons/RemoveCircle";
import styles from "../ItemsList/ItemsList.module.css";
import { useModal } from "../../../ModalContext";

const useStyles = makeStyles({
    root: {
        width: "100%",
    },
});

const MessageLogsGrid = (props) => {
    const createData = (messageLogs, control, fields) => {
        const created_at = moment(messageLogs.created_at).format(
            "DD.MM.YYYY HH:mm:ss",
        );
        const updated_at = moment(messageLogs.updated_at).format(
            "DD.MM.YYYY HH:mm:ss",
        );
        const status = formatStatus(messageLogs.status, fields);

        return {
            ...messageLogs,
            created_at,
            updated_at,
            status,
        };
    };

    const { showModal } = useModal();

    const renderReservationIcon = (
        <svg
            fill="none"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.97 22.75H4.96997C1.21997 22.75 1.21997 20.67 1.21997 19V18C1.21997 17.04 2.00997 16.25 2.96997 16.25H20.97C21.93 16.25 22.72 17.04 22.72 18V19C22.72 20.67 22.72 22.75 18.97 22.75ZM2.96997 17.75C2.82997 17.75 2.71997 17.86 2.71997 18V19C2.71997 20.64 2.71997 21.25 4.96997 21.25H18.97C21.22 21.25 21.22 20.64 21.22 19V18C21.22 17.86 21.11 17.75 20.97 17.75H2.96997Z"
                fill="black"
            />
            <path
                d="M20.72 17.75H3.27002C2.86002 17.75 2.52002 17.41 2.52002 17V13C2.52002 8.9 5.43002 5.3 9.43002 4.45C10.02 4.32 10.64 4.25 11.27 4.25H12.72C13.36 4.25 13.98 4.32 14.57 4.45C18.57 5.31 21.47 8.91 21.47 13V17C21.47 17.41 21.14 17.75 20.72 17.75ZM4.02002 16.25H19.97V13C19.97 9.61 17.57 6.63 14.25 5.91C13.76 5.8 13.25 5.75 12.72 5.75H11.27C10.75 5.75 10.24 5.8 9.75002 5.91C6.43002 6.62 4.02002 9.6 4.02002 13V16.25Z"
                fill="black"
            />
            <path
                d="M9.59 5.93C9.26 5.93 8.96 5.71 8.87 5.38C8.79 5.09 8.75 4.8 8.75 4.5C8.75 2.71 10.21 1.25 12 1.25C13.79 1.25 15.25 2.71 15.25 4.5C15.25 4.8 15.21 5.09 15.13 5.38C15.03 5.76 14.65 6 14.25 5.91C13.76 5.8 13.25 5.75 12.72 5.75H11.27C10.75 5.75 10.24 5.8 9.75 5.91C9.7 5.92 9.65 5.93 9.59 5.93ZM11.27 4.25H12.72C13.06 4.25 13.41 4.27 13.74 4.31C13.65 3.43 12.9 2.75 12 2.75C11.1 2.75 10.36 3.43 10.26 4.31C10.6 4.27 10.93 4.25 11.27 4.25Z"
                fill="black"
            />
            <path
                d="M15 11.75H9C8.59 11.75 8.25 11.41 8.25 11C8.25 10.59 8.59 10.25 9 10.25H15C15.41 10.25 15.75 10.59 15.75 11C15.75 11.41 15.41 11.75 15 11.75Z"
                fill="black"
            />
        </svg>
    );

    const requestIcon = (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8 5H6C5.46957 5 4.96086 5.21071 4.58579 5.58579C4.21071 5.96086 4 6.46957 4 7V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 19V18.5M8 5C8 5.53043 8.21071 6.03914 8.58579 6.41421C8.96086 6.78929 9.46957 7 10 7H12C12.5304 7 13.0391 6.78929 13.4142 6.41421C13.7893 6.03914 14 5.53043 14 5M8 5C8 4.46957 8.21071 3.96086 8.58579 3.58579C8.96086 3.21071 9.46957 3 10 3H12C12.5304 3 13.0391 3.21071 13.4142 3.58579C13.7893 3.96086 14 4.46957 14 5M14 5H16C16.5304 5 17.0391 5.21071 17.4142 5.58579C17.7893 5.96086 18 6.46957 18 7V7.5"
                stroke="#1F1F1F"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M19 11L21 13L19 15M13 15L11 13L13 11M16.75 10L16.5 11L16 13L15.5 15L15.25 16"
                stroke="#1F1F1F"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );

    const classes = useStyles();
    const rows = props.resData.AllItems.map((res) =>
        createData(res, undefined, props.fields),
    );

    const sortMessageLogs = (params) => {
        const sortParams = { ...params };
        const { sortField } = { ...sortParams };
        if (!sortableFields.includes(sortField)) return undefined;

        switch (sortParams.sortOrder) {
            case ASC:
                sortParams.sortOrder = DESC;
                break;
            case DESC:
                sortParams.sortOrder = ASC;
                break;
        }

        props.updateGlobalSearch(
            {
                ...props.globalSearch.search[props.versionFilter],
                sortOrder: sortParams.sortOrder,
                sortField,
            },
            props.versionFilter,
        );

        return props.paramsChangeHandler({
            ...props.getParams,
            sortField: sortField,
            sortOrder: sortParams.sortOrder,
        });
    };

    const updatingEnvironment = (page) => {
        props.paramsChangeHandler({
            ...props.getParams,
            page,
        });
        props.updateGlobalSearch(
            {
                ...props.globalSearch.search[props.versionFilter],
                page,
            },
            props.versionFilter,
        );
    };

    const changePage = (page) => {
        const params = {
            sortOrder: props.sortOrder,
            sortField: props.sortField,
        };

        switch (page) {
            case FIRST_PAGE:
                if (props.resData.currentPage !== 1) {
                    updatingEnvironment(1);
                }
                break;
            case PREV_PAGE:
                if (
                    props.resData.prevPageUrl &&
                    1 !== props.resData.currentPage
                ) {
                    const prevPageUrlArr = props.resData.prevPageUrl.split("=");
                    const prevPageNum =
                        prevPageUrlArr[prevPageUrlArr.length - 1];

                    updatingEnvironment(prevPageNum);
                }
                break;
            case NEXT_PAGE:
                if (
                    props.resData.nextPageUrl &&
                    props.resData.lastPage !== props.resData.currentPage
                ) {
                    const nextPageUrlArr = props.resData.nextPageUrl.split("=");
                    const nextPageNum =
                        nextPageUrlArr[nextPageUrlArr.length - 1];

                    updatingEnvironment(nextPageNum);
                }
                break;
            case LAST_PAGE:
                if (props.resData.lastPage !== props.resData.currentPage) {
                    updatingEnvironment(props.resData.lastPage);
                }
        }
    };

    return (
        <Paper className={classes.root}>
            <Table aria-label="custom pagination table">
                <TableHead>
                    <TableRow key="header">
                        {props.columns.map((column) => (
                            <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                    minWidth: column.minWidth,
                                    fontWeight: 400,
                                }}
                                onClick={() => {
                                    sortMessageLogs({
                                        sortField: column.id,
                                        sortOrder: props.getParams.sortOrder,
                                        page: props.resData.currentPage,
                                    });
                                }}
                            >
                                {column.label}
                                {renderSortArrow(
                                    props.getParams.sortField,
                                    props.getParams.sortOrder,
                                    column.id,
                                )}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => {
                        return (
                            <TableRow
                                hover
                                tabIndex={-1}
                                key={`${row.id}/${row.created_at}`}
                            >
                                {props.columns.map((column) => {
                                    if (column.id === "entity_id") {
                                        return (
                                            <TableCell>
                                                <Button
                                                    component={Link}
                                                    className={
                                                        styles.render__reservation
                                                    }
                                                    to={`/hotels/${props.hotelId}/reservations/${row.entity_id}/edit`}
                                                >
                                                    <span>
                                                        {renderReservationIcon}
                                                    </span>
                                                </Button>
                                            </TableCell>
                                        );
                                    } else if (
                                        column.id === "request" &&
                                        row.request
                                    ) {
                                        return (
                                            <TableCell>
                                                <Button
                                                    className={
                                                        styles.button__req__res
                                                    }
                                                    onClick={() =>
                                                        showModal(row.request)
                                                    }
                                                >
                                                    Запрос
                                                    <span
                                                        className={
                                                            styles.button__icon
                                                        }
                                                    >
                                                        {requestIcon}
                                                    </span>
                                                </Button>
                                            </TableCell>
                                        );
                                    } else if (
                                        column.id === "response" &&
                                        row.response
                                    ) {
                                        return (
                                            <TableCell>
                                                <Button
                                                    className={
                                                        styles.button__req__res
                                                    }
                                                    onClick={() =>
                                                        showModal(row.response)
                                                    }
                                                >
                                                    Ответ
                                                    <span
                                                        className={
                                                            styles.button__icon
                                                        }
                                                    >
                                                        {requestIcon}
                                                    </span>
                                                </Button>
                                            </TableCell>
                                        );
                                    } else if (column.id === "remove_button") {
                                        return (
                                            <TableCell>
                                                <ThemeProvider
                                                    theme={removeButtonTheme}
                                                >
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        startIcon={
                                                            <RemoveCircle />
                                                        }
                                                        onClick={() =>
                                                            props.removeAction(
                                                                row.id,
                                                                `Элемент с id = ${row.id}`,
                                                            )
                                                        }
                                                    >
                                                        {""}
                                                    </Button>
                                                </ThemeProvider>
                                            </TableCell>
                                        );
                                    } else {
                                        const value = row[column.id];
                                        return (
                                            <TableCell
                                                key={`${value}/${column.id}`}
                                                align={column.align}
                                            >
                                                {value}
                                            </TableCell>
                                        );
                                    }
                                })}
                            </TableRow>
                        );
                    })}
                    <TableRow>
                        <TableCell colSpan={10} align={"right"}>
                            <span
                                style={{
                                    verticalAlign: "middle",
                                    margin: "1rem",
                                }}
                            >
                                На странице:{" "}
                                {`${props.resData.AllItems.length}/${props.resData.perPage}`}
                            </span>
                            <span style={{ verticalAlign: "middle" }}>
                                <Tooltip title={"Первая страница"}>
                                    <span
                                        onClick={() => changePage(FIRST_PAGE)}
                                        style={{ margin: "1rem" }}
                                        className={
                                            1 !== props.resData.currentPage
                                                ? css["pagination-arrows"]
                                                : css[
                                                      "pagination-arrows__inactive"
                                                  ]
                                        }
                                    >
                                        <ArrowBackIosIcon
                                            fontSize={
                                                MATERIAL_UI_PROPS.sizes.small
                                            }
                                        />
                                        <ArrowBackIosIcon
                                            fontSize={
                                                MATERIAL_UI_PROPS.sizes.small
                                            }
                                        />
                                    </span>
                                </Tooltip>
                                <Tooltip title={"Предыдущая страница"}>
                                    <span
                                        style={{ margin: "0.5rem" }}
                                        onClick={() => changePage(PREV_PAGE)}
                                        className={
                                            1 !== props.resData.currentPage
                                                ? css["pagination-arrows"]
                                                : css[
                                                      "pagination-arrows__inactive"
                                                  ]
                                        }
                                    >
                                        <ArrowBackIosIcon
                                            fontSize={
                                                MATERIAL_UI_PROPS.sizes.small
                                            }
                                        />
                                    </span>
                                </Tooltip>
                                <div style={{ display: "inline-block" }}>
                                    <span
                                        style={{
                                            fontWeight: "900",
                                            fontSize: "21px",
                                            position: "relative",
                                            top: "-2px",
                                        }}
                                    >
                                        {props.globalSearch.search[
                                            props.versionFilter
                                        ].page ?? 1}
                                    </span>
                                </div>
                                <Tooltip title={"Следующая страница"}>
                                    <span
                                        style={{ margin: "0.5rem" }}
                                        onClick={() => changePage(NEXT_PAGE)}
                                        className={
                                            props.resData.lastPage !==
                                            props.resData.currentPage
                                                ? css["pagination-arrows"]
                                                : css[
                                                      "pagination-arrows__inactive"
                                                  ]
                                        }
                                    >
                                        <ArrowForwardIosIcon
                                            fontSize={
                                                MATERIAL_UI_PROPS.sizes.small
                                            }
                                        />
                                    </span>
                                </Tooltip>
                                <Tooltip title={"Последняя страница"}>
                                    <span
                                        onClick={() => changePage(LAST_PAGE)}
                                        style={{ margin: "1rem" }}
                                        className={
                                            props.resData.lastPage !==
                                            props.resData.currentPage
                                                ? css["pagination-arrows"]
                                                : css[
                                                      "pagination-arrows__inactive"
                                                  ]
                                        }
                                    >
                                        <ArrowForwardIosIcon
                                            fontSize={
                                                MATERIAL_UI_PROPS.sizes.small
                                            }
                                        />
                                        <ArrowForwardIosIcon
                                            fontSize={
                                                MATERIAL_UI_PROPS.sizes.small
                                            }
                                        />
                                    </span>
                                </Tooltip>
                            </span>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Paper>
    );
};

export default MessageLogsGrid;
